import React from "react";

interface CurrencySymbolProps {
    className?: string;
    currency?: string;
}

const CurrencySymbol: React.FC<CurrencySymbolProps> = ({ className, currency }) => {
    // ff-aed is the AED-specific font glyph class — only apply it for AED.
    // Other currencies render as plain text with no special font override.
    const isAED = !currency || currency === "AED";
    const classes = [isAED ? "ff-aed" : "", className].filter(Boolean).join(" ");
    return <span className={classes}>{currency || "AED"}</span>;
};

export default CurrencySymbol;
